import AppStoreBadge from '../AppStoreBadge';
import badge from '../../images/apple-store-badge.png';

const AppleAppStoreBadge: React.VFC<{}> = () => {
  return (
    <AppStoreBadge
      targetUrl='https://apps.apple.com/ca/app/mypeekaville/id1560170962'
      imageUrl={badge}
      altText='Download from App Store'
    />
  );
};

export default AppleAppStoreBadge;
